import type { ReactElement } from "react";

import { useTT } from "../useTT.ts";
import { ErrorNumbers } from "./ErrorNumbers.tsx";
import { ErrorPageContent } from "./ErrorPageContent.tsx";

export function Error404Content(): ReactElement {
  const { tt } = useTT();

  return (
    <ErrorPageContent
      graphic={<ErrorNumbers>404</ErrorNumbers>}
      title={tt("errorPages.Error404.title")}
      description={tt("errorPages.Error404.description")}
      buttonTitle={tt("errorPages.Error404.buttonTitle")}
      onButtonClick={() => (window.location.href = "/")}
    />
  );
}
